import { httpGet } from 'utils';
import { CurrentAllocation, RegionPerformance } from 'views/Portfolio/types';

interface CurrentAllocationResponse {
  regionPerformances: RegionPerformance[];
  portfolioCurrentAllocation: CurrentAllocation[];
}

export const fetchCurrentAllocations = () => httpGet<CurrentAllocationResponse>('portal/PortfolioCurrentAllocation');
